module.exports = {
  __depends__: [
    require(80),
    require(98),
    require(73)
  ],
  __init__: [ 'labelEditingProvider' ],
  labelEditingProvider: [ 'type', require(11) ]
};